export default __webpack_public_path__ + "static/media/Resume.f9c2d1ae.pdf";